import { useState, useEffect, useRef, useCallback, useLayoutEffect } from "react";

export const useWindowResize = (includeAsCSSAttributes: boolean = false) => {

    const [sizes, setSizes] = useState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    });

    useLayoutEffect(() => {

      const updateWindowSize = () => {

        if ( includeAsCSSAttributes ) {
            document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
            document.documentElement.style.setProperty('--vw', `${window.innerWidth * 0.01}px`);
        }

        setSizes({
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight
        });

      }

      window.addEventListener('resize', updateWindowSize);
      updateWindowSize();

      return () => window.removeEventListener('resize', updateWindowSize);

    }, []);

    return sizes;
    
}